export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/inventory/list'),
  },
  {
    path: '/403',
    name: '403',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/utility/403'),
  },
  {
    path: '/versions',
    name: 'versions',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/utility/versions'),
  },
  {
    path: '/inventory',
    name: 'inventory',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/inventory/list'),
  },
  {
    path: '/inventory/requests',
    name: 'itemsRequests',
    meta: {
      authRequired: true,
      role: 'hasInventoryAccess',
    },
    component: () => import('./views/inventory/requests'),
  },
  {
    path: '/inventory/manage/:idPublic',
    name: 'manageItem',
    meta: {
      authRequired: true,
      role: 'hasInventoryAccess',
    },
    component: () => import('./views/inventory/management'),
  },
  {
    path: '/inventory/:catTypeIdPublic',
    name: 'inventoryPerCatTypeIdPublic',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/inventory/list'),
  },
  {
    path: '/workorders',
    name: 'workOrders',
    meta: {
      authRequired: true,
      role: 'hasWorkOrdersAccess',
    },
    component: () => import('./views/work-orders/list'),
  },
  {
    path: '/workorders/manage/:idPublic',
    name: 'manageWorkOrder',
    meta: {
      authRequired: true,
      role: 'hasWorkOrdersAccess',
    },
    component: () => import('./views/work-orders/management'),
  },
  {
    path: '/orders',
    name: 'orders',
    meta: {
      authRequired: true,
      role: 'hasOrdersAccess',
    },
    component: () => import('./views/orders/list'),
  },
  {
    path: '/orders/creation/add',
    name: 'createOrder',
    meta: {
      authRequired: true,
      role: 'hasOrdersAccess',
    },
    component: () => import('./views/orders/creation/add'),
  },
  {
    path: '/orders/manage/:idPublic',
    name: 'manageOrder',
    meta: {
      authRequired: true,
      role: 'hasOrdersAccess',
    },
    component: () => import('./views/orders/management'),
  },
  {
    path: '/receptions',
    name: 'receptions',
    meta: {
      authRequired: true,
      role: 'hasReceptionsAccess',
    },
    component: () => import('./views/receptions/list'),
  },
  {
    path: '/receptions/manage/:idPublic',
    name: 'manageReception',
    meta: {
      authRequired: true,
      role: 'hasReceptionsAccess',
    },
    component: () => import('./views/receptions/management'),
  },
  {
    path: '/configuration/categories',
    name: 'categoriesConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/categories'),
  },
  {
    path: '/configuration/categories/create',
    name: 'createCategory',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/categories/form'),
  },
  {
    path: '/configuration/categories/:idPublic',
    name: 'editCategory',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/categories/form'),
  },
  {
    path: '/configuration/categorytypes',
    name: 'categoryTypesConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/categorytypes'),
  },
  {
    path: '/configuration/categorytypes/:idPublic',
    name: 'editCategoryType',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/categorytypes/form'),
  },
  {
    path: '/configuration/allocationgroups',
    name: 'allocationgroupsConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/allocationgroups'),
  },
  {
    path: '/configuration/allocations',
    name: 'allocationsConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/allocations'),
  },
  {
    path: '/configuration/items',
    name: 'itemsConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/items'),
  },
  {
    path: '/configuration/items/create',
    name: 'createItem',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/items/form'),
  },
  {
    path: '/configuration/items/:idPublic',
    name: 'editItem',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/items/form'),
  },
  {
    path: '/configuration/users',
    name: 'usersConfig',
    meta: {
      authRequired: true,
      adminOnly: true,
    },
    component: () => import('./views/configuration/users'),
  },
  {
    path: '/configuration/users/:idPublic',
    name: 'editUser',
    meta: {
      authRequired: true,
      adminOnly: true,
    },
    component: () => import('./views/configuration/users/form'),
  },
  {
    path: '/configuration/suppliers',
    name: 'suppliersConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/suppliers'),
  },
  {
    path: '/configuration/suppliers/create',
    name: 'createSupplier',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/suppliers/form'),
  },
  {
    path: '/configuration/suppliers/:idPublic',
    name: 'editSupplier',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/suppliers/form'),
  },
  {
    path: '/configuration/importations',
    name: 'importationsConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/importations'),
  },
  {
    path: '/configuration/orders',
    name: 'ordersConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/orders'),
  },
  {
    path: '/configuration/organization',
    name: 'organizationConfig',
    meta: {
      authRequired: true,
      role: 'hasConfigAccess',
      adminAccess: true,
    },
    component: () => import('./views/configuration/organization'),
  },
  {
    path: '/dashboards/prices',
    name: 'pricesDashboard',
    meta: {
      authRequired: true,
      role: 'hasDashboardsAccess',
    },
    component: () => import('./views/dashboards/prices'),
  },
  {
    path: '/dashboards/pricehistories',
    name: 'priceHistoriesDashboard',
    meta: {
      authRequired: true,
      role: 'hasDashboardsAccess',
    },
    component: () => import('./views/dashboards/price-histories'),
  },
  {
    path: '/cart',
    name: 'shoppingCart',
    meta: {
      authRequired: true,
      role: 'hasShoppingCartAccess',
    },
    component: () => import('./views/shopping-cart'),
  },
  {
    path: '/externals/:lang/orders/:orgcode/:idPublic',
    name: 'externalOrder',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/externals/orders'),
  },
  {
    path: '/shared/:orgcode/consumption/:type/:id',
    name: 'sharedItem',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/shared/consumption'),
  },

  // {
  //   path: '/404',
  //   name: '404',
  //   component: require('./views/utility/404').default,
  // },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
];
